import { ShedQuery } from 'dashboard-services/api/shed';

import { useMutation } from '@tanstack/react-query';

export default (() => {
  const useGenerateHtml = ({ getQueryBuilder, template, sourceFileInputs, ...rest }) =>
    useMutation({
      ...ShedQuery.QUERIES.generateHtml(
        getQueryBuilder,
        {
          template,
          sourceFileInputs
        }
      ),
      ...rest
    })

  const useGeneratePdf = ({ getQueryBuilder, html, ...rest }) =>
    useMutation({
      ...ShedQuery.QUERIES.generatePdf(
        getQueryBuilder,
        {
          html
        }
      ),
      ...rest
    })

  return {
    useGenerateHtml,
    useGeneratePdf
  }
})()